import { React } from '@digsup/core-ui';
import { PropTypes } from 'prop-types';
import { Grid } from '@digsup/components-grid';

export const PricingRow = ({ children }) => (
  <Grid gutter="small" rowGutter="xsmall">
    {children}
  </Grid>
);

PricingRow.propTypes = {
  children: PropTypes.any,
};
